import React from 'react';
import { SkipNavLink, SkipNavContent } from '@reach/skip-nav';

import DarkOverlay from '@common/DarkOverlay';
import Header from '@components/academy/header/Header';
import Footer from '@components/academy/footer/Footer';

const AcademyLayout = ({ children }) => {
  return (
    <>
      <Header />
      <DarkOverlay/>
      <SkipNavLink>{'Skip to Content'}</SkipNavLink>
      <SkipNavContent>{children}</SkipNavContent>
      <Footer />
    </>
  )
}

export default AcademyLayout
